module.exports = __webpack_public_path__ + "static/media/stackoverflow.ee2ef93e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Follow/stackoverflow.svg
// module id = 627
// module chunks = 0